/** Dims the page around the highlighted control; purely visual (the rest of the page is made inert). */
export const spotlightClassName =
  'pointer-events-none fixed z-40 rounded-lg shadow-[0_0_0_9999px_rgb(15_23_42/0.55)] ring-2 ring-primary transition-[top,left,width,height] duration-200';

/** Whole-page dim while there is no control to point at. */
export const fullBlockerClassName = 'fixed inset-0 z-40 bg-[rgb(15_23_42/0.55)]';

/** Breathing room between the control and the spotlight edge, in px. */
export const SPOTLIGHT_PADDING = 6;

/** Above the dimmed page so it stays readable and its skip button clickable. */
export const demoBadgeClassName = 'fixed top-3 left-1/2 z-50 -translate-x-1/2';
